<template>
  <v-container>
    <v-card elevation="8">
      <!--card title-->
      <v-card-title>
        <v-container>
          <span class="list-labels">Endereço</span>
        </v-container>
      </v-card-title>

      <!--card content-->
      <v-card-text>
        <v-container class="grid-list-sm">
          <v-row>
            <v-col cols="12" md="7">
              <v-container fluid pa-0>
                <v-row>
                  <v-col cols="12" md="7">
                    <v-text-field
                      label="CEP"
                      outlined
                      hide-details="auto"
                      required
                      v-mask="'#####-###'"
                      v-model="formData.postalCode"
                      :rules="[validatePostalCode]"
                      @blur="findAddressByCep"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      label="Bairro"
                      outlined
                      hide-details="auto"
                      required
                      v-model="formData.neighborhood"
                      :rules="[validateNeighborhood]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="7">
                    <v-text-field
                      label="Logradouro"
                      outlined
                      hide-details="auto"
                      required
                      v-model="formData.street"
                      :rules="[validateStreet]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      label="Número"
                      outlined
                      hide-details="auto"
                      required
                      v-model="formData.number"
                      :rules="[validateNumber]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Complemento"
                      outlined
                      hide-details="auto"
                      v-model="formData.complement"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Cidade"
                      outlined
                      hide-details="auto"
                      required
                      v-model="formData.city"
                      :rules="[validateCity]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-combobox
                      :items="formData.stateList"
                      item-text="shortName"
                      label="Estado"
                      outlined
                      hide-details="auto"
                      required
                      v-model="formData.state"
                      :rules="[validateState]"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col cols="12" md="5">
              <!-- API google - static MAP - imagem) -->
              <v-img
                class="br-4"
                lazy-src="https://system4delaware.com/wp-content/uploads/2018/02/delaware-blur-map.jpg"
                :src="
                  `https://maps.googleapis.com/maps/api/staticmap?center=${formData.googleAddress}&&zoom=16&size=400x400&key=AIzaSyCtHC295UPpQz7IafjhBEKFD3l9fnti71s`
                "
                height="100%"
                aspect-ratio="2"
                cover
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="var(--gray-light)"
                      background="var(--bg)"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import GeneralService from "@/scripts/services/general.service";
import cep from 'cep-promise';

export default {
  props: {
    registeredAddress: {
      type: Object,
      required: false
    }
  },
  name: "AddressForm",
  data: function() {
    return {
      formData: {
        googleAddress: "",
        postalCode: "",
        neighborhood: "",
        street: "",
        number: "",
        complement: "",
        city: "",
        state: ""
      }
    };
  },
  watch: {
    formData: {
      handler: function() {
        this.$emit("newdata", [
          this.formData.googleAddress,
          this.formData.postalCode,
          this.formData.neighborhood,
          this.formData.street,
          this.formData.number,
          this.formData.complement,
          this.formData.city,
          this.formData.state
        ]);
      },
      deep: true
    }
  },
  created() {
    new GeneralService()
      .listAllStates()
      .then(result => (this.formData.stateList = result));

    this.formData = {
      googleAddress: this.registeredAddress.GoogleAddress,
      postalCode: this.registeredAddress.PostalCode,
      neighborhood: this.registeredAddress.Neighborhood,
      street: this.registeredAddress.Street,
      number: this.registeredAddress.Number,
      complement: this.registeredAddress.Complement,
      city: this.registeredAddress.City,
      state: this.registeredAddress.State
    };
  },
  methods: {
    findAddressByCep() {
      cep(this.formData.postalCode).then((response) => {
        this.formData.state = response.state;
        this.formData.city = response.city;
        this.formData.neighborhood = response.neighborhood;
        this.formData.street = response.street;
      });
    },
    placechanged(formattedPlace) {
      this.formData.postalCode = formattedPlace.postalCode || "";
      this.formData.street = formattedPlace.street || "";
      this.formData.number = formattedPlace.number || "";
      this.formData.neighborhood = formattedPlace.neighborhood || "";
      this.formData.city = formattedPlace.city || "";
      this.formData.state = formattedPlace.state || "";
    },
    validateGoogleAddress() {
      if (!this.formData.googleAddress) return "Preencha o endereço";
      return true;
    },
    validatePostalCode() {
      if (!this.formData.postalCode) return "Preencha o CEP";
      return true;
    },
    validateStreet() {
      if (!this.formData.street) return "Preencha o logradouro";
      return true;
    },
    validateNeighborhood() {
      if (!this.formData.neighborhood) return "Preencha o bairro";
      return true;
    },
    validateNumber() {
      if (!this.formData.number) return "Preencha o número";
      return true;
    },
    validateCity() {
      if (!this.formData.city) return "Preencha a cidade";
      return true;
    },
    validateState() {
      if (!this.formData.state) return "Preencha o estado";
      return true;
    }
  }
};
</script>